import { forwardRef, type SVGProps } from 'react';

export const MiscColorWheelIcon = forwardRef<SVGSVGElement, Omit<SVGProps<SVGSVGElement>, 'css'>>((props, ref) => (
  <svg aria-hidden="true" ref={ref} {...props} viewBox="0 0 32 32">
    <g transform="rotate(90 0 16) scale(.016)">
      <foreignObject height="2000" width="2000" x="-1000" y="-1000">
        <div
          style={{
            background:
              'conic-gradient(from 90deg,red 0deg,#ff7f00 57.6deg,#ff0 118.8deg,#0f0 180deg,#0ff 237.6deg,#00f 298.8deg,#8b00ff 327.6deg,red 360deg)',
            borderRadius: '100%',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
    </g>
  </svg>
));

MiscColorWheelIcon.displayName = 'MiscColorWheelIcon';
